import styled from 'styled-components'
import { Trans } from 'react-i18next'
import { useTranslation } from 'next-i18next'

import { CheckoutQA } from 'shared/dataAttributes'
import { FCLink } from 'shared/components/Links'
import { colors } from 'shared/lib'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'

const TP = 'checkout.panels.ExpressCheckout.ExpressCheckout'

type ExpressCheckoutProps = {
  className?: string
}

export const ExpressCheckout = ({ className }: ExpressCheckoutProps) => {
  const { applePayAvailable, ExpressPayButton } = useCheckoutContext()
  const { t } = useTranslation()

  if (!applePayAvailable) {
    return null
  }

  return (
    <>
      {ExpressPayButton && (
        <Wrapper className={className}>
          <ExpressPayButton />
          <Disclaimer data-qa={CheckoutQA.ExpressDisclaimerText}>
            <Trans
              i18nKey={`${TP}.acknowledge`}
              t={t}
              defaults="By purchasing, I acknowledge that I have read and agree to the <0>Terms & Conditions</0> and <1>the Privacy Policy</1>."
              components={[
                <FCLink
                  key="/terms-conditions"
                  href="/terms-conditions"
                  newTab
                  qaAttr={CheckoutQA.ExpressTermsConditionsLink}
                />,
                <FCLink
                  key="/privacy"
                  href="/privacy"
                  newTab
                  qaAttr={CheckoutQA.ExpressPrivacyPolicyLink}
                />,
              ]}
            />
          </Disclaimer>
        </Wrapper>
      )}
    </>
  )
}

const Wrapper = styled.div`
  min-height: 70px;
`
const Disclaimer = styled.div`
  color: ${colors.FC2_GREY};
  font-size: 12px;
  margin-top: 20px;
`
